var YepNopeMessagePopup = require("app/AppLayout/YepNopeMessagePopup"),
    frameThrottle       = require("enyo-perf/utils").frameThrottle,
    kind                = require("enyo/kind");

require("app/theme/IconButton--positive.less");
require("app/theme/IconButton--negative.less");

module.exports = kind(/** @lends  app.PWA.InstallPopup.prototype */ {

    /**
     * @private
     */
    name: "app.PWA.InstallPopup",

    /**
     * @private
     */
    kind: YepNopeMessagePopup,

    /**
     * @private
     */
    classes: "app-pwa-install-popup",

    /**
     * No close button for this one.
     *
     * @public
     */
    showCloseButton: false,

    /**
     * @private
     */
    handlers: {
        onclick:                "onClick",
        onMessageYepButtonTap:  "onMessageYepButtonTap",
        onMessageNopeButtonTap: "onMessageNopeButtonTap"
    },

    /**
     * @method
     * @private
     */
    initComponents: kind.inherit(function(sup) {
        return function() {
            sup.apply(this, arguments);
            this.$.message.$.yepButton.set("theme", "positive");
            this.$.message.$.nopeButton.set("theme", "negative");
        };
    }),

    /**
     * @method
     * @private
     */
    create: kind.inherit(function(sup) {
        return function() {
            this.update = frameThrottle(this.bindSafely(this.update));
            sup.apply(this, arguments);
            this.observe("app.$.i18nService.translation", this.update);
            this.observe("app.$.installPromptService.canPrompt", this.canPromptChanged);
            this.update();
        };
    }),

    /**
     * @public
     */
    update: function() {
        var i18nService = this.app.$.i18nService,
            $message    = this.$.message;

        $message.$.title.set("content", i18nService.getString("app.PWA.InstallPopup.title"));
        $message.$.body.set("content", i18nService.getString("app.PWA.InstallPopup.body"));
        $message.$.yepButton.set("caption", i18nService.getString("app.PWA.InstallPopup.YesButton.caption"));
        $message.$.yepButton.set("tooltip", i18nService.getString("app.PWA.InstallPopup.YesButton.tooltip"));
        $message.$.nopeButton.set("caption", i18nService.getString("app.PWA.InstallPopup.NoButton.caption"));
        $message.$.nopeButton.set("tooltip", i18nService.getString("app.PWA.InstallPopup.NoButton.tooltip"));
    },

    /**
     * Add an event listener to show the deferred installPrompt on click.
     *
     * Chrome only allows displaying the deferred prompt from inside the handler
     * of the click event. Any degree of indirection and it does not work.
     * Therefore, we *must* add the listener explicitly instead of relying on
     * Enyo's event handling.
     *
     * @private
     */
    rendered: kind.inherit(function(sup) {
        return function() {
            var yesButtonNode,
                clickHandler;

            sup.apply(this, arguments);

            yesButtonNode = this.$.message.$.yepButton.hasNode();
            clickHandler  = this.app.$.installPromptService.showInstallPrompt;
            yesButtonNode && yesButtonNode.addEventListener("click", clickHandler);
        };
    }),

    /**
     * Since we added our own eventListener on render, we also need to remove it
     * again.
     *
     * @private
     */
    beforeTeardown: kind.inherit(function(sup) {
        return function() {
            var yesButtonNode,
                clickHandler;

            sup.apply(this, arguments);

            yesButtonNode = this.$.message.$.yepButton.hasNode();
            clickHandler  = this.app.$.installPromptService.showInstallPrompt;
            yesButtonNode && yesButtonNode.removeEventListener("click", clickHandler);
        };
    }),

    /**
     * Close this popup as soon as the install prompt is showing.
     *
     * @private
     */
    canPromptChanged: function() {
        if (!this.app.$.installPromptService.canPrompt) {
            this.close();
        }
    },

    /**
     * The install prompt *needs* a click event. Tap is the result of a mouseup,
     * which is not accepted. Therefore we simply ignore the tap event.
     *
     * @returns  {boolean}  Stop propagation.
     * @private
     */
    onMessageYepButtonTap: function() {
        return true;
    },

    /**
     * Close the popup
     *
     * @private
     */
    onMessageNopeButtonTap: function() {
        this.close();
    }

});
